import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import MessageTextCircle02Icon from "@redotech/redo-icons/message-text-circle-02.svg";
import MessageTextCircle02IconFilled from "@redotech/redo-icons/message-text-circle-02_filled.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const TextConciergeItems = memo(function TextConciergeItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const team = useRequiredContext(TeamContext);
  const location = useLocation();

  const flagLoad = useLoad(
    (signal) =>
      marketingRpcClient.getBooleanFeatureFlag(
        { key: FeatureFlagKey.SHOPPER_AGENT },
        { signal },
      ),
    [marketingRpcClient],
  );

  const isEnabled = flagLoad.value?.enabled ?? false;

  const conciergeEnabled = team.settings.shopperAgent?.enabled ?? false;

  const anyChildSelected = !!matchPath(
    `${routes.textConciergeHref}/*`,
    location.pathname,
  );

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.textConciergeHref }}
      anyChildSelected={anyChildSelected}
      FilledIcon={MessageTextCircle02IconFilled}
      friendlyName="Text Concierge"
      hidden={!isEnabled}
      id="text-concierge"
      UnfilledIcon={MessageTextCircle02Icon}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getTextConciergeSubRoute("conversations"),
        }}
        friendlyName="Conversations"
        hidden={!conciergeEnabled}
        id="text-concierge-conversations"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getTextConciergeSubRoute("settings"),
        }}
        friendlyName="Settings"
        hidden={!conciergeEnabled}
        id="text-concierge-settings"
      />
    </RedoSecondaryNavItem>
  );
});
